/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2025, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    d="M11.4258 6.3799c3.8321.0001 6.9382 3.1064 6.9385 6.9385v4.708l.0234.0019c1.1663.1186 2.0762 1.1042 2.0762 2.3018l-.0118.2363c-.1107 1.0884-.976 1.9538-2.0644 2.0645l-.2363.0117H4.2734l-.2373-.0117c-1.0883-.1107-1.9537-.9762-2.0644-2.0645l-.0117-.2363c0-1.1975.91-2.1832 2.0761-2.3018l.2373-.0117h.213v-4.6982c.0001-3.8322 3.1072-6.9385 6.9394-6.9385M4.2734 19.5166a.814.814 0 0 0-.8134.8135c.0003.4487.3646.8125.8134.8125h13.878a.813.813 0 0 0 0-1.626zm7.1768-4.2178a.7003.7003 0 0 0-.7002.7002.7004.7004 0 0 0 .7002.7002.7007.7007 0 0 0 .7002-.7002c0-.3864-.3136-.7-.7002-.7002m0-4.5488a.7003.7003 0 0 0-.7002.7002l.3496 2.4492c.0001.3149.3506.3496.3506.3496.0113-.0012.3495-.04.3496-.3496l.3506-2.4492a.7005.7005 0 0 0-.7002-.7002m-8.3516 1.0713a.75.75 0 0 1 0 1.5H.75a.75.75 0 0 1 0-1.5zm19.2159 0a.75.75 0 0 1 0 1.5h-2.3487a.75.75 0 0 1 0-1.5zM3.6357 5.209a.75.75 0 0 1 1.0606 0L6.3574 6.869A.7499.7499 0 1 1 5.297 7.9297L3.6357 6.2695a.75.75 0 0 1 0-1.0605m14.4717 0a.75.75 0 0 1 1.0606 1.0605l-1.6612 1.6602a.75.75 0 0 1-1.0605 0 .75.75 0 0 1 0-1.0606zM11.4258 2a.75.75 0 0 1 .75.75v2.3486a.75.75 0 0 1-1.5 0V2.75a.75.75 0 0 1 .75-.75"
  />,
  'MenuIncidentFilled'
);
